import React, { Component } from 'react';
import Header from './header.jsx'
import Hidden from './hidden.jsx'
import Buy from './buy.jsx'
import Sell from './sell.jsx'
import Spread from './spread.jsx'

class Orderbook extends Component {
  render() {
    return (
      <div>
        <h6 style={{marginLeft:'2px',marginTop:0,color:'white'}}>Order Book <Hidden/> </h6>
        <div className='col s12 section' >
          <Header/>
          <Sell/>
          <Spread/>
          <Buy/>
        </div>
      </div>
		)
  }
}

export default Orderbook
